import { render } from "./sysConfig.vue?vue&type=template&id=33ee0755&scoped=true"
import script from "./sysConfig.vue?vue&type=script&lang=js"
export * from "./sysConfig.vue?vue&type=script&lang=js"

import "./sysConfig.vue?vue&type=style&index=0&id=33ee0755&scoped=true&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ee0755"]])

export default __exports__